export const KINDERGARTENS = '/';
export const CALLBACK = '/callback';
export const UNATHORIZED = '/unathorized';
export const INFOBOARD = '/infoboard';
export const KINDERGARTEN_DETAILS = `${KINDERGARTENS}/:kindergartenId/details`;
export const LOCATIONS_CREATE = `${KINDERGARTENS}/:kindergartenId/locations/create/:kindergartenName`;
export const GROUP_DETAILS = `${KINDERGARTENS}/:kindergartenId/groups/:groupId/details/:kindergartenName/:locationName`;
export const TEACHERS_CREATE = `${KINDERGARTENS}/:kindergartenId/teacher/create/:kindergartenName`;
export const TEACHER_EDIT = `${KINDERGARTENS}/:kindergartenId/teacher/:teacherId/edit/:kindergartenName`;
export const TEACHER_DETAILS = `${KINDERGARTENS}/:kindergartenId/teacher/:teacherId/details/:kindergartenName`;
export const CHILD_CREATE = `${KINDERGARTENS}/:kindergartenId/child/create/:kindergartenName`;
export const CHILD_EDIT = `${KINDERGARTENS}/:kindergartenId/child/:childId/edit/:kindergartenName`;
export const CHILD_DETAILS = `${KINDERGARTENS}/:kindergartenId/child/:childId/details/:kindergartenName`;
export const PARENT_CREATE = `${KINDERGARTENS}/:kindergartenId/parent/create/:kindergartenName`;
export const PARENT_EDIT = `${KINDERGARTENS}/:kindergartenId/parent/:parentId/edit/:kindergartenName`;
export const PARENT_DETAILS = `${KINDERGARTENS}/:kindergartenId/parent/:parentId/details/:kindergartenName`;
export const POST_CREATE = `${INFOBOARD}/post/create`;
export const POST_EDIT = `${INFOBOARD}/post/:postId/edit`;
export const EVENT_CREATE = `${KINDERGARTENS}/:kindergartenId/event/create/:kindergartenName`;
export const EVENT_DETAILS = `${KINDERGARTENS}/:kindergartenId/groups/:groupId/event-configuration/:kindergartenName/:locationName`;

export const FINANCE = '/finance';
/** Invoices, with their generation runs as a second tab. */
export const FINANCE_INVOICES = `${FINANCE}/invoices`;
/** Which children can be invoiced: contract number and payer. */
export const FINANCE_CONTRACTS = `${FINANCE}/contracts`;
/** One child's contract: the Contracts page opens straight on its panel. */
export const contractHref = (kindergartenId: string, childId: string) =>
  `${FINANCE_CONTRACTS}?kindergartenId=${kindergartenId}&childId=${childId}`;
/** What each child or family still owes. */
export const FINANCE_DEBTS = `${FINANCE}/debts`;
/** Super admin only: the catalogue every kindergarten inherits. */
export const FINANCE_PLATFORM_ITEMS = `${FINANCE}/platform-items`;
/** Billing configuration: settings, the catalogue and the per-group schemes. */
export const FINANCE_SETTINGS = `${FINANCE}/settings`;
export const FINANCE_LOCATION = `${FINANCE}/location/:locationId`;
export const FINANCE_GROUP = `${FINANCE}/location/:locationId/group/:groupId`;
export const INVOICE_CREATE = `${FINANCE}/invoice/create`;
export const INVOICE_DETAILS = `${FINANCE}/invoice/:invoiceId`;
export const INVOICE_BATCH_DETAILS = `${FINANCE}/batch/:batchId`;
